export default {
      id: "icc-logo-usage",
      viewBox: "0 0 277.215 445.031",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#icc-logo",
      toString: function () {
        return this.url;
      }
    }